export default {
    links: [
        {
            path: '/home',
            name: 'Home',
            icon: 'fas fa-home',
            filtered: false,
            pinned: true,
        },
        {
            name: 'Dashboard',
            icon: 'fas fa-chart-line',
            children: [
                {
                    path: '/dashboard',
                    name: 'Dashboard',
                    filtered: true,
                },
                {
                    path: '/dashboard/sales-overview',
                    name: 'Sales overview',
                    filtered: false,
                    scope: ['read_sales_overview'],
                    bypassPositions: ['regional_manager', 'state_manager', 'sales', 'inbound_team_leader'],
                },
                {
                    path: '/dashboard/sales',
                    name: 'Sales',
                    filtered: false,
                    scope: ['read_sales_commissions', 'read_charts_salespeople'],
                    bypassPositions: ['regional_manager', 'state_manager', 'sales'],
                },
                {
                    path: '/dashboard/inbound-sales',
                    name: 'Inbound sales',
                    filtered: false,
                    scope: ['read_sales_commissions', 'read_charts_salespeople'],
                    bypassPositions: ['inbound_sales', 'inbound_team_leader'],
                },
                {
                    path: '/dashboard/customer-success',
                    name: 'Customer success',
                    filtered: false,
                    scope: ['read_customer_success'],
                    bypassPositions: ['customer_success', 'state_manager', 'partner_manager', 'inbound_team_leader'],
                },
            ],
        },
        {
            name: 'Accounts',
            icon: 'fas fa-user-friends',
            children: [
                {
                    path: '/accounts',
                    name: 'Accounts',
                    scope: ['read_accounts', 'write_accounts'],
                    filtered: true,
                },
                {
                    path: '/leads',
                    name: 'Leads',
                    filtered: false,
                    scope: ['read_leads', 'write_leads', 'write_own_leads'],
                },
                {
                    path: '/activations',
                    name: 'Activations',
                    filtered: false,
                    scope: ['read_activations', 'write_activations'],
                },
                {
                    path: '/global-accounts',
                    name: 'Global Accounts',
                    filtered: true,
                    scope: ['read_accounts', 'write_accounts'],
                }
            ],
        },
        {
            name: 'Process',
            icon: 'fas fa-money-bill',
            children: [
                {
                    path: '/transactions',
                    name: 'Transactions',
                    filtered: true,
                    scope: ['read_transactions', 'write_transactions'],
                },
                {
                    path: '/withdrawals',
                    name: 'Withdrawals',
                    filtered: true,
                    scope: ['read_withdrawals', 'write_withdrawals', 'block_withdrawals'],
                },
                {
                    path: '/payouts',
                    name: 'Payouts',
                    filtered: true,
                    scope: ['read_payouts'],
                },
                {
                    path: '/chargebacks',
                    name: 'Chargebacks',
                    filtered: true,
                    scope: ['read_chargebacks', 'write_chargebacks'],
                },
                {
                    path: '/refunds',
                    name: 'Refunds',
                    filtered: true,
                    scope: ['read_refunds'],
                },
                {
                    path: '/activitys',
                    name: 'Activity',
                    filtered: true,
                    scope: ['read_activity', 'write_activity'],
                },
                {
                    path: '/invoices',
                    name: 'Invoices',
                    filtered: true,
                    scope: ['read_invoices', 'write_invoices'],
                },
                {
                    path: '/transfers',
                    name: 'Transfers',
                    filtered: true,
                    scope: ['read_transfers', 'write_transfers'],
                },
                {
                    path: '/integrations',
                    name: 'Integrations',
                    filtered: true,
                    scope: ['read_integrations', 'write_integrations'], 
                },
                {
                    path: '/direct-debits',
                    name: 'Direct Debits',
                    filtered: true,
                    scope: ['read_direct_debits', 'write_direct_debits'],
                },
                {
                    path: '/subscriptions',
                    name: 'Subscriptions',
                    filtered: true,
                    scope: ['read_subscriptions', 'write_subscriptions'],
                },
            ],
        },
        {
            name: 'Risk & Security',
            icon: 'fas fa-shield-alt',
            children: [
                {
                    path: '/risks',
                    name: 'Risks',
                    filtered: false,
                    scope: ['read_risks'],
                },
                {
                    path: '/business-reviews',
                    name: 'Business Reviews',
                    filtered: true,
                    scope: ['read_business_reviews'],
                },
                {
                    path: '/rules',
                    name: 'Rules',
                    filtered: true,
                    scope: ['read_rules', 'write_rules'],
                },
                {
                    path: '/whitelist',
                    name: 'Whitelists',
                    filtered: true,
                    scope: ['read_whitelist', 'write_whitelist'],
                },
                {
                    path: '/bin-manager',
                    name: 'Bin Manager',
                    filtered: false,
                    scope: ['read_bin_manager'],
                },
                {
                    path: '/blacklisted-cards',
                    name: 'Blacklisted Cards',
                    filtered: true,
                    scope: ['read_blacklisted_cards', 'write_blacklisted_cards'],
                },
                {
                    path: '/prohibited-products',
                    name: 'Prohibited Products',
                    filtered: false,
                    scope: ['read_prohibited_products', 'write_prohibited_products'],
                },
                {
                    path: '/prohibited-product-reviews',
                    name: 'Prohibited Product Reviews',
                    filtered: false,
                    scope: ['read_prohibited_products', 'write_prohibited_products'],
                },
            ],
        },
        {
            name: 'Hardware',
            icon: 'fas fa-cash-register',
            children: [
                {
                    path: '/pos-information',
                    name: 'Terminals',
                    filtered: true,
                    scope: ['read_pos_information', 'write_pos_information'],
                },
                {
                    path: '/pos-rental-fees',
                    name: 'Rental Fees',
                    filtered: true,
                    scope: ['read_pos_information', 'write_pos_information'],
                },
                {
                    path: '/terminal-orders',
                    name: 'Terminal Orders',
                    filtered: true,
                    scope: ['read_terminal_orders', 'write_terminal_orders'],
                },
                {
                    path: '/tap-to-phone-devices',
                    name: 'Tap to Phone',
                    filtered: true,
                    scope: ['read_pos_information', 'write_pos_information'],
                },
            ],
        },
        {
            name: 'Administration',
            icon: 'fas fa-clipboard-list',
            children: [
                {
                    path: '/reports',
                    name: 'Reports',
                    filtered: true,
                    scope: ['read_reports', 'report_accounts'],
                },
                {
                    path: '/affiliations',
                    name: 'Affiliations',
                    filtered: true,
                    scope: ['read_affiliations', 'write_affiliations'],
                },
                {
                    path: '/acquirers',
                    name: 'Acquirers',
                    filtered: false,
                    scope: ['read_acquirers', 'write_acquirers'],
                },
                {
                    path: '/affiliation-catalogs',
                    name: 'Affiliation catalog',
                    filtered: false,
                    scope: ['read_affiliation_catalogs', 'write_affiliation_catalogs'],
                },
                {
                    path: '/affiliation-requests',
                    name: 'Affiliation Requests',
                    filtered: true,
                    scope: ['read_accounts', 'read_affiliations', 'write_affiliations'],
                },
                {
                    path: '/commercialpartners',
                    name: 'Partners',
                    filtered: false,
                    scope: ['read_accounts', 'write_accounts'],
                },
                {
                    path: '/admins',
                    name: 'Admins',
                    filtered: false,
                    scope: ['read_admins', 'write_admins'],
                },
                {
                    path: '/profiles',
                    name: 'Profiles',
                    filtered: false,
                    scope: ['read_profiles', 'write_profiles'],
                },
                {
                    path: '/banks',
                    name: 'Banks',
                    filtered: false,
                    scope: ['read_banks', 'write_banks'],
                },
                {
                    path: '/reconciliations',
                    name: 'Reconciliations',
                    filtered: false,
                    scope: ['read_reconciliations', 'write_reconciliations'],
                },
                {
                    path: '/webhook-logs',
                    name: 'Webhook Logs',
                    filtered: false,
                    scope: ['read_webhookslogs'],
                },
                ...(import.meta.env.PROD ? [{
                    path: '/audit-logs',
                    name: 'Audit Logs',
                    filtered: false,
                    scope: ['read_audit_logs'],
                }] : []),
                {
                    path: '/timelines',
                    name: 'Timelines',
                    filtered: true,
                    scope: ['read_timelines'],
                },
                {
                    path: '/dashboard/mongodb',
                    name: 'Dashboard MongoDB',
                    filtered: false,
                    scope: ['read_dashboard_mongodb'],
                },
                {
                    path: '/notification-campaigns',
                    name: 'Notification Campaigns',
                    filtered: false,
                    scope: ['read_notification_campaigns', 'write_notification_campaigns'],
                },
                {
                    path: '/risk-analysis',
                    name: 'Risk Analysis',
                    filtered: false,
                    scope: ['access_tendencys_risk'],
                },
                {
                    path: '/arena',
                    name: 'Arena',
                    filtered: false,
                    scope: ['access_arena'],
                },
            ],
        },
        {
            path: '/charts',
            name: 'Charts',
            icon: 'fas fa-chart-line',
            filtered: true,
            scope: ['read_charts'],
            bypassPositions: ['regional_manager', 'state_manager', 'sales'],
        },
        {
            name: 'AI',
            icon: 'fas fa-robot',
            children: [
                {
                    path: '/ai-overview',
                    name: 'Overview',
                    filtered: false,
                    scope: ['read_ai_conversations'],
                },
                {
                    path: '/ai-knowledge',
                    name: 'Knowledge',
                    filtered: false,
                    scope: ['read_ai_conversations'],
                },
                {
                    path: '/ai-models',
                    name: 'Models',
                    filtered: false,
                    scope: ['read_ai_conversations'],
                },
                {
                    path: '/ai-tools',
                    name: 'Tools & actions',
                    filtered: false,
                    scope: ['read_ai_conversations'],
                },
                {
                    path: '/ai-behavior',
                    name: 'Behavior & tone',
                    filtered: false,
                    scope: ['read_ai_conversations'],
                },
                {
                    path: '/ai-guardrails',
                    name: 'Guardrails',
                    filtered: false,
                    scope: ['read_ai_conversations'],
                },
                {
                    path: '/ai-conversations',
                    name: 'Conversations',
                    filtered: false,
                    scope: ['read_ai_conversations'],
                },
                {
                    path: '/ai-learning',
                    name: 'Learning inbox',
                    filtered: false,
                    scope: ['read_ai_conversations'],
                },
            ],
        }
    ],
    otherLinks: [
        {
            path: '/dashboard/profile',
            name: 'Your Profile',
            icon: 'fas fa-user',
        },
        {
            path: '/tickets',
            name: 'Ticket tracking',
            icon: 'fas fa-clipboard-list',
        },
        {
            href: 'https://forms.clickup.com/9011975628/f/8cjfnec-2471/5XFTJDB25C6JQQT2XJ',
            name: 'Create ticket',
            icon: 'fas fa-question',
        },
    ],
};
